import { getCurrentAccountSearch } from '@/graphql/queries/banking/current-account';
import { getProviderWithCurrentAccounts } from '@/graphql/queries/shared/institution';
import { COOKIE_CURRENT_ACCOUNT_SEARCH } from '@/constants/cookies';
import lang from '@/lang/middleware/products/banking/current-accounts';

export default async ({ $apolloQuery, $cookies, route, store }) => {
  const code = $cookies.get(COOKIE_CURRENT_ACCOUNT_SEARCH);
  const search = code ? await $apolloQuery(getCurrentAccountSearch, { code }) : {};
  store.commit('search/reset', { type: 'current', search });

  await $apolloQuery(getProviderWithCurrentAccounts, { slug: route.params.provider }).then(provider => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const description = store.$i18n.t('provider.description', { provider: provider.name });
    const title = store.$i18n.t('provider.title', { provider: provider.name });
    store.commit('pageContent/setHead', { title, description });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'],
      ['i18n/banking', '/money/'],
      ['i18n/current-accounts', '/compare-current-accounts/'],
      ['i18n/providers', '/compare-current-accounts/providers/'],
      provider.name
    ]);

    store.commit('blog/setList', provider.articles);
    store.commit('products/setList', provider.current_accounts);
    delete provider.articles;
    delete provider.current_accounts;
    store.commit('jumbotron/SET_JUMBOTRON', { title, type: 'generic' });
    store.commit('providers/set', provider);
  });
};
